import { render, staticRenderFns } from "./ReleasePackageArchitecture.vue?vue&type=template&id=6f37f228"
import script from "./ReleasePackageArchitecture.vue?vue&type=script&lang=js"
export * from "./ReleasePackageArchitecture.vue?vue&type=script&lang=js"
import style0 from "./ReleasePackageArchitecture.vue?vue&type=style&index=0&id=6f37f228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports